export default {
    PROTOCOLO: 1,
    ETIQUETA: 2,
    PROTOCOLO_ETIQUETA: 3,
}